import { TypographyProps } from '@mui/material';
import { BodySmallBoldStyled, BodySmallRegularStyled } from 'v3/shared/typography/BodySmall/styles';

export const BodySmallBold: React.FC<TypographyProps> = (props) => {
  return (
    <BodySmallBoldStyled variant="button" {...props}>
      {props.children}
    </BodySmallBoldStyled>
  );
};

export const BodySmallRegular: React.FC<TypographyProps> = (props) => {
  return (
    <BodySmallRegularStyled variant="body2" {...props}>
      {props.children}
    </BodySmallRegularStyled>
  );
};
